import { Box } from "@mui/material";
import { IAds } from "../interfaces/IAds";
import AdsComponent from "../Components/AdsComponent";
import { useEffect } from "react";
import { Helmet } from "react-helmet-async";

const AdSection: React.FC<{ data?: IAds[] }> = ({ data }) => {
  return (
    <div className="">
      {data?.map((ad) => (
        <Box key={ad.id} className="mb-4">
          {ad?.script_url && (
            <Helmet>
              <script src={ad?.script_url} async></script>
            </Helmet>
          )}
          {ad.image && <img src={ad.image_url} className="w-full" />}
          {ad?.ad_script && (
            <div
              dangerouslySetInnerHTML={{
                __html: ad?.ad_script as string,
              }}
            />
          )}
          {ad?.ad_slot && <AdsComponent data={ad} />}
        </Box>
      ))}
    </div>
  );
};

export default AdSection;
